import { all } from 'redux-saga/effects';

import config from '../../../../config';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import getWatchExceptions from 'react-redux-app/lib/modules/exception/saga';
import auth from '../../auth/sagas';
import campaignsGrid from '../../campaign/sagas/grids/campaignsGrid';
import payoutRequestsGrid from '../../payout/sagas/grids/payoutRequestsGrid';
import sitesGrid from '../../site/sagas/grids/sitesGrid';
import createPreparation from '../../site/sagas/createPreparation';
import siteAliasesFilter from '../../siteAlias/sagas/filter';
import siteAliasesGrid from '../../siteAlias/sagas/grids/siteAliasesGrid';
import siteArticlesGrid from '../../siteArticle/sagas/grids/siteArticlesGrid';
import siteSeoGrid from '../../siteSeo/sagas/grids/siteSeoGrid';
import siteFooterLinkCategoriesGrid from '../../siteFooterLinks/sagas/grids/siteFooterLinkCategoriesGrid';
import siteFooterLinksGrid from '../../siteFooterLinks/sagas/grids/siteFooterLinksGrid';
import siteTextsGrid from '../../siteTexts/sagas/grids/siteTextsGrid';
import siteCustomTagsGrid from '../../siteSeo/sagas/grids/siteCustomTagsGrid';
import pagesGrid from '../../siteStaticPages/sagas/grids/pagesGrid';
import webmasterBalance from '../../webmaster/sagas/balance';
import wire from '../../wire/sagas';


export default function* saga(history) {
  yield all([
    getWatchExceptions(INTERNAL_ERROR_URI, config.isDevToolsEnabled)(),
    auth(history),
    campaignsGrid(history),
    payoutRequestsGrid(history),
    sitesGrid(history),
    createPreparation(history),
    siteAliasesFilter(history),
    siteAliasesGrid(history),
    siteArticlesGrid(history),
    siteSeoGrid(),
    siteFooterLinkCategoriesGrid(),
    siteFooterLinksGrid(),
    siteTextsGrid(),
    siteCustomTagsGrid(history),
    pagesGrid(),
    webmasterBalance(history),
    wire(history),
  ]);
}
